import { render } from "./registerComponent.vue?vue&type=template&id=2961f45a"
import script from "./registerComponent.vue?vue&type=script&lang=js"
export * from "./registerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__